module.exports = __webpack_public_path__ + "img/Group1408@2x.8ab78030.png";